module.exports = __webpack_public_path__ + "static/media/PDF_133.532761bf.pdf";